import { glow } from "@/vessels";

export const birdFlags = { on: false };
const rand = (a, b) => a + Math.random() * (b - a);
const TINTS = ["48,100%,78%", "265,80%,82%", "20,95%,80%", "190,80%,82%", "0,0%,96%"];

export const makeBird = (w, h, x = rand(-w * 0.1, w)) => ({
  x, y: rand(h * 0.1, h * 0.85), size: rand(10, 26) * Math.max(0.6, Math.min(w, h) / 900),
  vx: rand(1.4, 3.2), ph: rand(0, 6.28), flap: rand(7, 11), tint: TINTS[Math.floor(Math.random() * TINTS.length)],
});

export const drawBird = (ctx, b, t, flying) => {
  const a = flying ? Math.sin(t * b.flap + b.ph) * 0.9 : 0.15 + Math.sin(t * 0.8 + b.ph) * 0.05;
  const s = b.size;
  ctx.globalCompositeOperation = "lighter";
  glow(ctx, b.x, b.y, s * 2.6, b.tint, 0.18);
  ctx.strokeStyle = `hsla(${b.tint},0.85)`;
  ctx.lineWidth = Math.max(1.5, s * 0.18);
  ctx.lineCap = "round";
  [-1, 1].forEach((side) => {
    ctx.beginPath();
    ctx.moveTo(b.x, b.y);
    ctx.quadraticCurveTo(b.x + side * s * 0.7, b.y - s * (0.2 + a * 0.9), b.x + side * s * 1.5, b.y - s * a * 0.6);
    ctx.stroke();
  });
  glow(ctx, b.x, b.y, s * 0.5, "0,0%,100%", 0.6);
};

const makeBat = (w, h, x = rand(-w * 0.1, w)) => ({ ...makeBird(w, h, x), tint: BAT_TINTS[Math.floor(Math.random() * BAT_TINTS.length)], jit: rand(0, 6.28) });
const BAT_TINTS = ["265,60%,80%", "230,50%,82%", "300,40%,80%", "0,0%,88%"];

const drawBat = (ctx, b, t, flying) => {
  const a = flying ? Math.sin(t * b.flap * 1.6 + b.ph) : 0.3 + Math.sin(t * 1.1 + b.ph) * 0.2;
  const s = b.size;
  ctx.globalCompositeOperation = "lighter";
  glow(ctx, b.x, b.y, s * 2.4, b.tint, 0.14);
  ctx.fillStyle = `hsla(${b.tint},0.75)`;
  [-1, 1].forEach((side) => {
    const tipY = b.y - s * a * 0.9;
    ctx.beginPath();
    ctx.moveTo(b.x, b.y - s * 0.15);
    ctx.quadraticCurveTo(b.x + side * s * 0.8, b.y - s * (0.4 + a * 0.7), b.x + side * s * 1.7, tipY);
    ctx.quadraticCurveTo(b.x + side * s * 1.45, b.y + s * 0.15, b.x + side * s * 1.2, b.y + s * 0.05);
    ctx.quadraticCurveTo(b.x + side * s * 1.0, b.y + s * 0.35, b.x + side * s * 0.7, b.y + s * 0.12);
    ctx.quadraticCurveTo(b.x + side * s * 0.45, b.y + s * 0.4, b.x, b.y + s * 0.2);
    ctx.fill();
  });
  ctx.beginPath(); ctx.ellipse(b.x, b.y, s * 0.22, s * 0.32, 0, 0, Math.PI * 2); ctx.fill();
  [-1, 1].forEach((side) => {
    ctx.beginPath(); ctx.moveTo(b.x + side * s * 0.08, b.y - s * 0.25); ctx.lineTo(b.x + side * s * 0.18, b.y - s * 0.48); ctx.lineTo(b.x + side * s * 0.2, b.y - s * 0.22); ctx.fill();
  });
};

export const birdsong = {
  id: "birdsong",
  name: "Bats",
  subtitle: "Soft glowing bats flitting across the night sky",
  init(w, h) {
    return { bats: Array.from({ length: 16 }, () => makeBat(w, h)) };
  },
  draw(ctx, w, h, t, s, p, k) {
    ctx.globalCompositeOperation = "source-over";
    ctx.fillStyle = "rgba(8,6,22,0.24)";
    ctx.fillRect(0, 0, w, h);
    const flying = birdFlags.on;
    window.__birdsFlying = flying;
    window.__batsFrames = (window.__batsFrames || 0) + 1;
    s.bats.forEach((b, i) => {
      if (Math.random() < 0.03 * k) b.jit += rand(-1.6, 1.6);
      b.x += (flying ? b.vx * 1.2 : 0.3) * k + Math.cos(b.jit) * (flying ? 1.1 : 0.25) * k;
      b.y += Math.sin(b.jit) * (flying ? 1.3 : 0.3) * k + Math.sin(t * 3 + b.ph) * (flying ? 0.6 : 0.15) * k;
      if (b.y < -40) b.y = h + 30;
      if (b.y > h + 40) b.y = -30;
      if (b.x - b.size * 2 > w) s.bats[i] = makeBat(w, h, -b.size * 2);
      if (b.x < -b.size * 4) b.jit = 0;
      drawBat(ctx, b, t, flying);
    });
  },
};
